module.exports = __webpack_public_path__ + "src/assets/img/dilo_team.216a5736.svg";